import React from 'react'
import PageWrapper from '../../components/PageWrapper'
// import LightAddIcon from '../../assets/icons/LightAddIcon'
import ViewProperty from './ViewProperty'
import Metadata from '../../components/Metadata'

  const propertyMetadata = {
    title: 'Property - Safelto',
    description: 'View and manage all properties in your estate. Complete property management solution for residential communities.',
    keywords: ['property', 'property management', 'estate properties', 'residential properties', 'property listing'],
    image: '/assets/images/safelto-big.png',
    url: 'https://safelto.com/property',
    type: 'website' as 'website'
  }

  const Property = () => {
    const [currentView, setCurrentView] = React.useState('')
    // const [loading, setLoading] = React.useState(true)
    const isActiveView = (view: string) => {
      return view === currentView
    }
    const handleViewSelect = (view: string, queries?: Record<string, string>) => {
      if (isActiveView(view)) return;

      // Create query parameters with the selected view and additional queries
      const searchParams = new URLSearchParams({ active: view, ...queries });
      window.history.replaceState(null, '', `?${searchParams.toString()}`);

      setCurrentView(view);
    };

    React.useEffect(() => {
      const searchParams = new URLSearchParams(window.location.search);
      const searchObj = Object.fromEntries(searchParams.entries());

      setCurrentView(searchObj.active || 'view'); // Default to 'view' if no query is found
    }, []);

    return (
      <>
        <PageWrapper title="Property" description="View all Properties">
          <Metadata {...propertyMetadata} />
        <div>
          <ViewProperty handleViewSelect={handleViewSelect} />
        </div>
      </PageWrapper>
    </>
  )
}

export default Property;